import carouselExtNavCtrl from './carouselExtNav.ctrl.js';

export const carouselExtNavComponent = {
    controller: carouselExtNavCtrl,
    bindings: {},
};
